import React from 'react';

/** v4-web `stores-checkout-flow` back button SVG (41×41). */
const StoreCheckoutBackIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    aria-hidden
  >
    <path
      d="M20 40.5C31.0457 40.5 40 31.5457 40 20.5C40 9.4543 31.0457 0.5 20 0.5C8.9543 0.5 0 9.4543 0 20.5C0 31.5457 8.9543 40.5 20 40.5Z"
      fill="#FFFDFE"
    />
    <path
      d="M20.0005 40.0088C30.7768 40.0088 39.5127 31.2729 39.5127 20.4966C39.5127 9.72028 30.7768 0.984375 20.0005 0.984375C9.22419 0.984375 0.488281 9.72028 0.488281 20.4966C0.488281 31.2729 9.22419 40.0088 20.0005 40.0088Z"
      stroke="#AAB2C3"
    />
    <path
      d="M26.8294 20.5H13.1709"
      stroke="#AAB2C3"
      className="store-checkout-header__arrow-left"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.0002 27.3293L13.1709 20.5L20.0002 13.6707"
      className="store-checkout-header__arrow-left"
      stroke="#AAB2C3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

StoreCheckoutBackIcon.displayName = 'StoreCheckoutBackIcon';

export default StoreCheckoutBackIcon;
